import { Link } from "react-router";

export function CompactTrustFooter() {
  return (
    <footer className="border-t border-slate-200 bg-white px-5 py-6 text-center font-inter">
      <div className="mx-auto flex max-w-5xl items-center justify-center text-xs leading-relaxed text-slate-500">
        <nav
          aria-label="Legal and support links"
          className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 font-medium text-slate-600"
        >
          <Link to="/terms" className="hover:text-fp-emerald-600">
            Terms
          </Link>
          <Link to="/privacy" className="hover:text-fp-emerald-600">
            Privacy
          </Link>
          <Link to="/disclaimer" className="hover:text-fp-emerald-600">
            Disclaimer
          </Link>
          <Link to="/methodology" className="hover:text-fp-emerald-600">
            Methodology
          </Link>
          <Link to="/contact" className="hover:text-fp-emerald-600">
            Contact
          </Link>
        </nav>
      </div>
    </footer>
  );
}
